import { Component, OnInit, ChangeDetectionStrategy, TemplateRef, Input } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-two-columns',
    templateUrl: './two-columns.shared.component.html',
    styleUrls: ['./two-columns.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoColumnsComponent implements OnInit {
    public device$: Observable<OLO.Enums.DEVICE_TYPE>;

    @Input() public left: TemplateRef<any>;
    @Input() public right: TemplateRef<any>;
    @Input() public align: OLO.Components.TWO_COLUMNS_ALIGN = 'center';
    @Input() public adjust: OLO.Components.TWO_COLUMNS_ADJUST;
    @Input() public alignVertical: OLO.Components.TWO_COLUMNS_VERTICAL_ALIGN = 'centerV';
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public maxWidth: boolean = true;
    @Input() public mobileLeft: boolean; /* Hide left col on mobile */
    @Input() public mobileRight: boolean; /* Hide right col on mobile */

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.device$ = this.controllers.appSettings.deviceType$();
    }
}
